
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 18a2 2 0 01-1.4-.6A2 2 0 010 16V2Q0 1.2.6.6A2 2 0 012 0h14q.9 0 1.4.6.6.6.6 1.4v14q0 .9-.6 1.4a2 2 0 01-1.4.6zm0-2h14V4H2zm7-2q-2 0-3.7-1.1Q3.8 11.8 3 10a6 6 0 016-4q2 0 3.7 1.1Q14.2 8.2 15 10a6 6 0 01-6 4m0-2.5q-.7 0-1-.4-.6-.5-.5-1.1t.4-1q.5-.6 1.1-.5t1 .4q.6.5.5 1.1t-.4 1q-.5.6-1.1.5m0 1q1 0 1.8-.7.7-.7.7-1.8 0-1-.7-1.8-.7-.7-1.8-.7-1 0-1.8.7-.7.7-.7 1.8 0 1 .7 1.8.7.7 1.8.7","fill":"#fff"}})])
          )
        }
      }
    